export default __webpack_public_path__ + "static/garden_design25-fbd6124a7786f4f82de6eaadd2b47b9a.webp";